import React, { useState } from "react";
import { useQuery } from "react-query";
import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import { communication } from "../../constants/apis/communication";
import "./DonutAnalyticsCard.css";

const COLOR_HOD_APPROVED = "#89B9FF";
const COLOR_SUPERVISOR_APPROVED = "#AAFF75";
const COLOR_PENDING = "#FF958D";
const COLOR_REJECTED = "#FF9CF6";

export default function DonutAnalyticsCard() {
  const [activeIndex, setActiveIndex] = useState(-1);

  const { data: rawData, isLoading } = useQuery(
    ["productionApprovalCounts"],
    () => communication.getProductionApprovalCounts({}),
    {
      refetchOnWindowFocus: false,
    }
  );

  const apiData = rawData?.data?.data || null;

  const donutData = apiData ? [
    { name: "HOD Approved", value: apiData.hodApproved || 0, color: COLOR_HOD_APPROVED },
    { name: "Supervisor Approved", value: apiData.supervisorApproved || 0, color: COLOR_SUPERVISOR_APPROVED },
    { name: "Pending", value: apiData.pending || 0, color: COLOR_PENDING },
    { name: "Rejected", value: apiData.rejected || 0, color: COLOR_REJECTED }
  ].filter(item => item.value > 0) : [];

  const activeItem = activeIndex >= 0 && activeIndex < donutData.length ? donutData[activeIndex] : null;
  const totalUnits = donutData.reduce((acc, curr) => acc + curr.value, 0);

  return (
    <div className="card-premium d-flex align-items-center justify-content-between p-3 gap-2 donut-analytics-card">
      <div className="donut-chart-container">
        {isLoading ? (
          <div className="d-flex align-items-center justify-content-center h-100 w-100">
            <span style={{ fontSize: "14px", color: "#666" }}>Loading...</span>
          </div>
        ) : donutData.length === 0 ? (
          <div className="d-flex align-items-center justify-content-center h-100 w-100">
            <span style={{ fontSize: "14px", color: "#666" }}>No data</span>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                activeIndex={activeIndex}
                activeShape={{ outerRadius: 74 }}
                data={donutData}
                cx="50%"
                cy="50%"
                innerRadius={36}
                outerRadius={70}
                paddingAngle={6}
                cornerRadius={12}
                dataKey="value"
                onMouseEnter={(e, index) => setActiveIndex(index)}
                onMouseLeave={() => setActiveIndex(-1)}
                style={{ cursor: "pointer", outline: "none" }}
              >
                {donutData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} style={{ outline: "none" }} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        )}
      </div>
      <div className="donut-legend-container flex-1">
        <div className="legend-gray-box">
          {activeItem ? (
            <div className="dynamic-info-panel animate-fade-in text-center">
              <div className="d-flex align-items-center justify-content-center gap-2 mb-1">
                <span className="status-indicator-dot" style={{ backgroundColor: activeItem.color }}></span>
                <span className="info-title">{activeItem.name}</span>
              </div>
              <div className="info-value">
                <h3>{totalUnits > 0 ? ((activeItem.value / totalUnits) * 100).toFixed(1) : 0}%</h3>
                <p className="info-subtitle">{activeItem.value} of {totalUnits} Logs</p>
              </div>
            </div>
          ) : (
            <div className="default-info-panel text-center animate-fade-in">
              <h5 className="info-title-default">Approval Status</h5>
              <div className="info-value-default">{totalUnits} Logs</div>
              <p className="info-subtitle-default">Hover segments for info</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
